import React from 'react';
import { MessageSquare, Users } from 'lucide-react';
import DashboardModal from '@/components/dashboard-modal/DashboardModal';
import PostForm from './PostForm';
import { useCreateDiscussion, CreateDiscussionInput } from '@/hooks/community/use-community-discussions';

interface NewPostModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedCategory?: string;
}

const NewPostModal: React.FC<NewPostModalProps> = ({
  isOpen,
  onClose,
  selectedCategory
}) => {
  const createDiscussionMutation = useCreateDiscussion({ navigateToPost: true });

  const handleSubmit = async (data: CreateDiscussionInput) => {
    try {
      await createDiscussionMutation.mutateAsync(data);
      onClose();
    } catch (error) {
      // Error handling is done in the mutation hook
      console.error('Failed to create post:', error);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <DashboardModal
      isOpen={isOpen}
      onClose={onClose}
      title="Create New Post"
      size="lg"
      accentColor="purple"
      showCloseButton={true}
    >
      <div className="space-y-4">
        {/* Post Form */}
        <PostForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isSubmitting={createDiscussionMutation.isPending}
          initialValues={selectedCategory ? { category: selectedCategory } : undefined}
        />
      </div>
    </DashboardModal>
  );
};

export default NewPostModal; 